'use strict';

module.exports = function each(fn) {
  var _this = this;

  if (Array.isArray(this.items)) {
    this.items.forEach(fn);
  } else {
    Object.keys(this.items).forEach(function (key) {
      fn(_this.items[key], key, _this.items);
    });
  }

  return this;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/each.js
// module id = 1217
// module chunks = 2